// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as JsBindings from "../../../../../library/JS/JsBindings.bs.js";
import * as SliderThumbCmp from "./SliderThumbCmp.bs.js";
import * as SliderMarkingCmp from "./SliderMarkingCmp.bs.js";
import * as PartnerScoreHelper from "../../../domain/helper/PartnerScoreHelper.bs.js";
import * as SliderTrackSpanCmp from "./SliderTrackSpanCmp.bs.js";
import * as PartnerScoreV2CssHelper from "../../../domain/helper/PartnerScoreV2CssHelper.bs.js";
import * as SliderTrackMilestoneCmp from "./SliderTrackMilestoneCmp.bs.js";

function ScoreSliderTrackV2(Props) {
  var track_thresholds = Props.track_thresholds;
  var current_score = Props.current_score;
  var max_score = Props.max_score;
  var update_slider_track_height = Props.update_slider_track_height;
  var action_details = Props.action_details;
  React.useEffect((function () {
          var element = document.getElementById("slider-track");
          Curry._1(update_slider_track_height, JsBindings.offsetHeight(element));
          
        }), []);
  return React.createElement("div", {
              className: "slider-track-container-v2"
            }, React.createElement(SliderThumbCmp.make, {
                  current_score: current_score,
                  max_score: max_score
                }), React.createElement("div", {
                  className: "slider-track-v2",
                  id: "slider-track"
                }, Belt_Array.mapWithIndex(track_thresholds, (function (index, val) {
                        return React.createElement("div", {
                                    className: "slider-track-span-container-v2",
                                    style: {
                                      width: PartnerScoreV2CssHelper.getSliderSpanLength(max_score, PartnerScoreHelper.thresholdValueToFloat(val), PartnerScoreHelper.getPrevScore(index, track_thresholds))
                                    }
                                  }, React.createElement(SliderTrackMilestoneCmp.make, {
                                        track_thresholds: track_thresholds,
                                        current_score: current_score,
                                        max_score: max_score,
                                        action_details: action_details,
                                        index: index
                                      }), React.createElement(SliderTrackSpanCmp.make, {
                                        current_score: current_score,
                                        max_score: max_score,
                                        index: index
                                      }), React.createElement(SliderMarkingCmp.make, {
                                        index: index,
                                        val: val,
                                        track_thresholds: track_thresholds,
                                        max_score: max_score
                                      }));
                      }))));
}

var make = ScoreSliderTrackV2;

export {
  make ,
  
}
/* react Not a pure module */
